//
// SideMenuSubmenuFold
//
// Grows a submenu block open when it mounts and folds it shut when `open` drops,
// calling `onFolded` once the fold has played so the parent can unmount it.
//

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

function SideMenuSubmenuFold(props) {
  const {
    open,
    onFolded,
    children,
  } = props;

  // Mounted shut and opened on the next frame, so the growth is a transition
  // rather than the initial paint
  const [grown, setGrown] = useState(false);
  useEffect(
    () => {
      const frame = requestAnimationFrame(() => setGrown(true));
      return () => cancelAnimationFrame(frame);
    },
    [],
  );

  const shown = open && grown;

  return (
    <div
      className={classNames(
        'grid w-full transition-[grid-template-rows] duration-200 ease-out',
        {
          'grid-rows-[1fr]': shown,
          'grid-rows-[0fr]': !shown,
        },
      )}
      inert={!open}
      onTransitionEnd={(event) => {
        if ((!open) && (event.target === event.currentTarget)) onFolded();
      }}
    >
      <div className="overflow-hidden min-h-0 relative flex flex-col w-full">
        {children}
      </div>
    </div>
  );
}

SideMenuSubmenuFold.propTypes = {
  open: PropTypes.bool.isRequired,
  onFolded: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default SideMenuSubmenuFold;
